import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import {PackingContext} from "../PackingOrderList/PackingContext";
import Badge from "../../../../../components/Badge";
import MultiExpForceStopModal from "./MultiExpForceStopModal";

AlreadyInPackingModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleIsValid: PropTypes.func.isRequired
};

function AlreadyInPackingModal({open, handleClose, handleIsValid}) {
    const [stopMultiExpSession, setStopMultiExpSession] = useState(false)

    const {isMultiSessionPacking} = useContext(PackingContext)

    if (stopMultiExpSession) {
        return (
            <MultiExpForceStopModal open={stopMultiExpSession} handleClose={() => setStopMultiExpSession(false)}/>
        )
    }


    return (
        <Popup
            open={open}
            onClose={isMultiSessionPacking ? () => setStopMultiExpSession(true) : handleClose}
            title={<FormattedMessage id={"wms.packing.modal.alreadyInPacking.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.alreadyInPacking.subtitle"}/>}
            hideCloseIcon={isMultiSessionPacking}
            strictOnclose={isMultiSessionPacking}
        >
            <Grid container direction={"column"} gap={"8px"}>
                <CustomButton
                    color={"blue"}
                    fullWidth
                    onClick={handleIsValid}
                >
                    <FormattedMessage id={"wms.packing.modal.alreadyInPacking.valid"}/>
                </CustomButton>

                <CustomButton
                    color={"red"}
                    fullWidth
                    onClick={isMultiSessionPacking ? () => setStopMultiExpSession(true) : handleClose}
                >
                    <FormattedMessage id={"wms.packing.modal.alreadyInPacking.cancel"}/>
                </CustomButton>

                {isMultiSessionPacking && (
                    <Grid container justifyContent={'center'}>
                        <Badge
                            size={"large"}
                            rounded
                            label={<FormattedMessage id={"wms.packing.item.multiSessionPacking.notice"}/>}
                            color={"online"}
                        />
                    </Grid>
                )}
            </Grid>
        </Popup>
    );
}

export default AlreadyInPackingModal;